export enum SignatureImageType {
    Drawing = 1,
    Upload = 2
}